import { createAction, props } from '@ngrx/store';

export const loadTeams = createAction(
  '[Team] Load Teams',
);

export const loadTeamsSuccess = createAction(
  '[Team] Load Teams Success',
  props<{ teams: any[] }>()
);

export const loadTeamsFailure = createAction(
  '[Team] Load Teams Failure',
  props<{ error: any }>()
);

export const createTeam = createAction(
  '[Team] Create Team',
  props<{ team: any }>()
);
export const createTeamSuccess = createAction(
  '[Team] Create Team Success',
);
export const createTeamFailure = createAction(
  '[Team] Create Team Failure',
  props<{ error: any }>()
);

